(function () {
  function init(root) {
    if (!root || root.dataset.cartBound === 'true') return;

    root.dataset.cartBound = 'true';

    const button = root.querySelector('.tru-kit__add');
    const error = root.querySelector('.tru-kit__cart-error');

    if (!button) return;

    async function refreshAndOpenCartDrawer() {
      const base =
        window.Shopify && window.Shopify.routes
          ? window.Shopify.routes.root
          : '/';

      const cartResponse = await fetch(base + 'cart.js', {
        headers: {
          Accept: 'application/json'
        }
      });

      const cart = cartResponse.ok ? await cartResponse.json() : null;

      document.dispatchEvent(
        new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: cart ? { cart: cart } : {}
        })
      );

      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          bubbles: true,
          detail: cart ? { cart: cart } : {}
        })
      );

      window.dispatchEvent(
        new CustomEvent('cart:refresh', {
          detail: cart ? { cart: cart } : {}
        })
      );

      window.dispatchEvent(
        new CustomEvent('cart:updated', {
          detail: cart ? { cart: cart } : {}
        })
      );

      const drawer =
        document.querySelector('cart-drawer') ||
        document.querySelector('m-cart-drawer') ||
        document.querySelector('.m-cart-drawer') ||
        document.querySelector('#CartDrawer') ||
        document.querySelector('[data-cart-drawer]');

      if (drawer) {
        if (typeof drawer.renderContents === 'function' && cart) {
          try {
            drawer.renderContents(cart);
          } catch (e) {}
        }

        if (typeof drawer.open === 'function') {
          drawer.open();
          return;
        }

        if (typeof drawer.show === 'function') {
          drawer.show();
          return;
        }
      }

      const trigger =
        document.querySelector('[data-open-cart-drawer]') ||
        document.querySelector('[data-cart-drawer-trigger]') ||
        document.querySelector('.m-cart-icon-bubble') ||
        document.querySelector('.m-header__cart') ||
        document.querySelector('a[href="/cart"].m-cart-icon-bubble');

      if (trigger) {
        trigger.click();
        return;
      }

      document.dispatchEvent(
        new CustomEvent('cart:open', {
          bubbles: true,
          detail: cart ? { cart: cart } : {}
        })
      );

      window.dispatchEvent(
        new CustomEvent('cart:open', {
          detail: cart ? { cart: cart } : {}
        })
      );
    }

    button.addEventListener('click', async function () {
      const ids = (button.dataset.variantIds || '')
        .split(',')
        .filter(Boolean)
        .map(Number);

      if (!ids.length) return;

      button.disabled = true;
      error.hidden = true;

      const original = button.textContent;
      button.textContent = 'Adding…';

      const base =
        window.Shopify && window.Shopify.routes
          ? window.Shopify.routes.root
          : '/';

      try {
        const response = await fetch(base + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: ids.map(function (id) {
              return {
                id: id,
                quantity: 1
              };
            })
          })
        });

        if (!response.ok) {
          const data = await response.json().catch(function () {
            return {};
          });

          throw new Error(
            data.description ||
              data.message ||
              'Unable to add this kit. Please try again.'
          );
        }

        await refreshAndOpenCartDrawer();

        button.disabled = false;
        button.textContent = original;
      } catch (err) {
        error.textContent =
          err.message || 'Unable to add this kit. Please try again.';
        error.hidden = false;
        button.disabled = false;
        button.textContent = original;
      }
    });
  }

  function initAll(container) {
    if (container.matches && container.matches('.tru-kit')) {
      init(container);
    }

    container.querySelectorAll('.tru-kit').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();